













import { Vue, Component, Prop } from "vue-property-decorator";
import { IAccount } from "@/models/accounts";

@Component({
  components: {
    "commissions-history-table": () =>
      import("@/components/app/global/affiliate/commissionsHistoryTable.vue")
  }
})
export default class ClientAffiliateCommissionsView extends Vue {
  // Props
  @Prop({ required: true })
  public accountId!: IAccount["id"];
}
